import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RaterformComponent } from '../raterform/raterform/raterform.component';
import { FormField } from './form-field';

@Component({
  selector: 'app-dynamic-form-creator',
  templateUrl: './dynamicformcreator.component.html',
  styleUrls: ['./multifamily.component.css']
})
export class DynamicFormCreatorComponent {

  @Input() input: FormField<string>;
  @Input() form: FormGroup;
  @Input() component: RaterformComponent;

  get isValid() { return true; }


  onImageSelected(event, key: string) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        // Update the form model
        this.form.patchValue({
          [key + '_pic']: e.target.result // This is the data URL of the image
        });
      };
      reader.readAsDataURL(file);
    }
  }


}
